import { useContext, useMemo } from 'react';

import { selectVersion } from '@shared/helpers';
import { useSearchParams } from '@shared/hooks';
import { AccessType } from '@modules/access';
import { SignInContext, USER_GROUPS } from '@modules/users';

import { TLiterature, TLiteratureDraft, TLiteratureVersion } from '../types';

export const useLiteratureView = (literature: TLiterature, accessRight: AccessType) => {
  const { user } = useContext(SignInContext);
  const { searchParams } = useSearchParams();
  const view = searchParams.get('view');

  return useMemo(() => {
    const version = selectVersion<TLiteratureDraft, TLiteratureVersion>({
      draft: literature.draft,
      versions: literature.versions,
      view,
      canEdit: accessRight >= AccessType.EDIT,
      isAuthor: user.groups.includes(USER_GROUPS.AUTHOR),
    });
    return { version };
  }, [view, literature.draft, literature.versions, accessRight, user]);
};
